export default {
  SERVICE_SCOPE_ACCEPTED: 'SERVICE_SCOPE_ACCEPTED',
  SERVICE_SCOPE_REJECTED: 'SERVICE_SCOPE_REJECTED',
  SERVICE_SCOPE_UNKNOWN: 'SERVICE_SCOPE_UNKNOWN',
  SERVICE_SCOPE_ACCEPTED_ADDITIONAL: 'SERVICE_SCOPE_ACCEPTED_ADDITIONAL',
  SERVICE_SCOPE_REJECTED_ADDITIONAL: 'SERVICE_SCOPE_REJECTED_ADDITIONAL',
  SERVICE_SCOPE_UNKNOWN_ADDITIONAL: 'SERVICE_SCOPE_UNKNOWN_ADDITIONAL',
  SERVICE_SCOPE_ASKED_ADDITIONAL: 'SERVICE_SCOPE_ASKED_ADDITIONAL',
};
